module.exports = __webpack_public_path__ + "static/img/interseight.0d73664.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/interseight.png
// module id = MyMD
// module chunks = 45